/**
 * frontend/utils/displayName.js
 * Single source of truth for player / user identity display.
 */
export function getDisplayName(user) {
  if (!user) return 'Player';
  return user.display_name || user.email?.split('@')[0] || 'Player';
}
